var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "default-img" }, [
    _vm.error
      ? _c("div", {
          class: [_vm.spver === 1 ? "default-film" : "default-sogou"],
        })
      : _c("img", {
          attrs: { src: _vm.checkHttps(_vm.src), alt: _vm.iname },
          on: { error: _vm.imgError },
        }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }